enum ActivityType {
    Task = 1,
    Note = 2,
    Call = 3,
    Meeting = 4,
    Email = 5
}

export default ActivityType;

export const ActivityTypeLabels: { [key: number]: string } = {
    [ActivityType.Task]: 'Task',
    [ActivityType.Note]: 'Note',
    [ActivityType.Call]: 'Call',
    [ActivityType.Meeting]: 'Meeting',
    [ActivityType.Email]: 'Email'
};

export const ActivityTypeIcons: { [key: number]: string } = {
    [ActivityType.Task]: 'mdi-checkbox-marked-outline',
    [ActivityType.Note]: 'mdi-note-outline',
    [ActivityType.Call]: 'mdi-phone-incoming-outgoing-outline',
    [ActivityType.Meeting]: 'mdi-account-multiple-outline',
    [ActivityType.Email]: 'mdi-email'
};
